import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { baseApi } from "./api/baseApi";
import { authApi } from "./api/authApi";
import authReducer, { forceLogout } from "./slices/authSlice";
import workspaceReducer, { workspaceReset } from "./slices/workspaceSlice";
import recentTasksReducer from "./slices/recentTasksSlice";
import mdoDraftsReducer from "./slices/mdoDraftsSlice";
import tokenService from "../services/tokenService";
import { onForceLogout } from "../services/api";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    workspace: workspaceReducer,
    recentTasks: recentTasksReducer,
    mdoDrafts: mdoDraftsReducer,
    [baseApi.reducerPath]: baseApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(baseApi.middleware),
});

setupListeners(store.dispatch);

// Mirror the axios interceptor's force-logout into the store, so any
// component reading auth state from Redux reacts to a refresh-failure
// 401 the same way the existing onForceLogout listeners do. Wipe the
// RTK Query cache + workspaceSlice alongside so Account A's data
// doesn't survive into the next login session (cross-account leak
// in the sidebar / home / open task views).
onForceLogout(() => {
  store.dispatch(baseApi.util.resetApiState());
  store.dispatch(workspaceReset());
  store.dispatch(forceLogout());
});

// Hydrate the user profile at boot when a token is already on disk —
// the slice's initialState picks up isAuthenticated from localStorage,
// but `user` still needs to be fetched after a hard refresh.
if (tokenService.getAccessToken()) {
  store.dispatch(authApi.endpoints.fetchProfile.initiate());
}
